"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.OverflowMenuItemInnerWrapper = exports.OverflowMenuItem = exports.IconPlaceholder = exports.HiddenIconPlaceholder = exports.DisabledTextContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreDivider = require("@legacy-vfuk/core-divider");

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Text = _styledComponents["default"].span.withConfig({
  displayName: "OverflowMenuItemstyle__Text",
  componentId: "sc-letn3n-0"
})(function () {
  return (0, _styledComponents.css)(["", ";"], _coreMixins.typography.paragraph(1, false));
});

exports.Text = Text;

var getStylesForActiveElement = function getStylesForActiveElement(theme) {
  return (0, _styledComponents.css)(["background-color:", ";", "{font-weight:", ";}"], theme.color.monochrome2["default"], Text, theme.fontWeight[3]);
};

var OverflowMenuItem = _styledComponents["default"].li.withConfig({
  displayName: "OverflowMenuItemstyle__OverflowMenuItem",
  componentId: "sc-letn3n-1"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;background-color:", ";transition:0.4s all ease;position:relative;display:flex;flex-direction:column;justify-content:center;", ";cursor:pointer;", "{position:absolute;bottom:0;", ";}&:last-of-type ", "{display:none;}&:hover{", "}", " ", " ", ""], props.theme.color.monochrome1["default"], (0, _coreMixins.spacing)('padding', 3), _coreDivider.DividerStyles.Divider, (0, _coreMixins.responsiveCalc)('width', '100%', '-', 6), _coreDivider.DividerStyles.Divider, getStylesForActiveElement(props.theme), props.focused && (0, _styledComponents.css)(["", " &::before{outline:none;content:'';z-index:1;border:", " ", " ", ";position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;}&:first-child{&::before{border-radius:", " ", " 0 0;}}&:last-child{&::before{border-radius:0 0 ", " ", ";}}"], getStylesForActiveElement(props.theme), props.theme.border.width[1], props.theme.border.style[1], props.theme.color.focus["default"], props.theme.border.radius[2], props.theme.border.radius[2], props.theme.border.radius[2], props.theme.border.radius[2]), props.active && (0, _styledComponents.css)(["", ";"], getStylesForActiveElement(props.theme)), props.disabled && (0, _styledComponents.css)(["color:", ";background-color:", ";", "{font-weight:", ";}&:hover{background-color:", ";button{cursor:not-allowed;}", "{font-weight:", ";}}"], props.theme.color.disabled["default"], props.theme.color.monochrome1["default"], Text, props.theme.fontWeight[2], props.theme.color.monochrome1["default"], Text, props.theme.fontWeight[2]));
});

exports.OverflowMenuItem = OverflowMenuItem;

var OverflowMenuItemInnerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "OverflowMenuItemstyle__OverflowMenuItemInnerWrapper",
  componentId: "sc-letn3n-2"
})(function () {
  return (0, _styledComponents.css)(["display:flex;align-items:center;"]);
});

exports.OverflowMenuItemInnerWrapper = OverflowMenuItemInnerWrapper;

var IconPlaceholder = _styledComponents["default"].span.withConfig({
  displayName: "OverflowMenuItemstyle__IconPlaceholder",
  componentId: "sc-letn3n-3"
})(function (props) {
  return (0, _styledComponents.css)(["", ";display:inline-flex;align-items:center;", ""], (0, _coreMixins.spacing)('margin-right', 2), props.isIcon && props.disabled && (0, _styledComponents.css)(["[class*='Icon']{", "}"], (0, _coreMixins.iconAppearance)(props.theme.color.disabled["default"], props.group)));
});

exports.IconPlaceholder = IconPlaceholder;

var DisabledTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "OverflowMenuItemstyle__DisabledTextContainer",
  componentId: "sc-letn3n-4"
})(function (props) {
  return (0, _styledComponents.css)(["", ";display:flex;& > p{color:", ";}"], (0, _coreMixins.spacing)('padding-top', 1), props.theme.color.error["default"]);
});

exports.DisabledTextContainer = DisabledTextContainer;

var HiddenIconPlaceholder = _styledComponents["default"].span.withConfig({
  displayName: "OverflowMenuItemstyle__HiddenIconPlaceholder",
  componentId: "sc-letn3n-5"
})(function () {
  return (0, _styledComponents.css)(["", ";visibility:hidden;height:0;"], (0, _coreMixins.spacing)('margin-right', 2));
});

exports.HiddenIconPlaceholder = HiddenIconPlaceholder;
//# sourceMappingURL=OverflowMenuItem.style.js.map